import GovernoratesComponent from "../../../Components/system settings/GovernoratesComponent";
import HeaderBar from "../../../Components/UI/headerbar";

const GovernoratesPage = () => {
  return (
    <div>
      <HeaderBar
        title={"إعدادات المحافظات"}
        content={"إدارة المحافظات للنظام"}
      />

      <GovernoratesComponent />
    </div>
  );
};

export default GovernoratesPage;
